/**
 * What the mobile bottom bar shows: the first four rail entries, in order, and
 * the rest (which the More sheet lists first in a browser tab). Also the
 * per-star unread count, shared with the rail.
 */
import { destinationById } from '@shared/navigation/destinations';

import type { NavCounts } from '@app/stores/slices/uiSlice';
import type { Destination } from '@shared/navigation/destinations';

const BOTTOM_BAR_SLOTS = 4;

/** The unread count a starred destination shows, if it has one. */
export function countForStar(id: string, counts: NavCounts): number | null {
  switch (id) {
    case 'inbox':
      return counts.emailInbox;
    case 'starred':
      return counts.starredInbox;
    case 'reading-room':
      return counts.readLaterInbox;
    case 'drafts':
      return counts.drafts;
    default:
      return null;
  }
}

/** Rail ids resolved to destinations, in order, dropping unknown ids. */
function resolve(ids: readonly string[]): Destination[] {
  return ids.map(id => destinationById(id)).filter((d): d is Destination => d !== undefined);
}

/**
 * The bar's four slots and what More covers. Pure over the rail it is given:
 * the caller passes `useRail().ids`, so the bar and the sidebar cannot disagree.
 */
export function bottomBarSlots(ids: readonly string[]): {
  slots: Destination[];
  rest: Destination[];
} {
  const all = resolve(ids);
  return { slots: all.slice(0, BOTTOM_BAR_SLOTS), rest: all.slice(BOTTOM_BAR_SLOTS) };
}
